export const isEmpty = (str: any): boolean => {
    return str === undefined || str === null || (str.trim && str.trim().length === 0)
}
